import { createContext, useContext, useState, useEffect } from 'react';
import { authFetch } from '../../utils/api';
import Cookies from 'js-cookie';

const CrmSettingsContext = createContext({ settings: {}, setSettings: () => {} });

export const CrmSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    quote_manager_only: false,
    common_customers: false,
    require_transition_note: false,
    simple_crm_enabled: true,
    external_crm: 'none',
  });

  useEffect(() => {
    if (!Cookies.get('access_token')) return;
    authFetch('/crm/settings/')
      .then(data => {
        const map = {};
        (data || []).forEach(s => {
          // external_crm is a string enum ('none' | 'zoho'), not a boolean
          if (s.key === 'external_crm') {
            map[s.key] = s.value;
          } else {
            map[s.key] = s.value === 'true';
          }
        });
        setSettings(prev => ({ ...prev, ...map }));
      })
      .catch(() => {}); // fail silently — use defaults if backend unavailable
  }, []);

  return (
    <CrmSettingsContext.Provider value={{ settings, setSettings }}>
      {children}
    </CrmSettingsContext.Provider>
  );
};

export const useCrmSettings = () => useContext(CrmSettingsContext);
